import React, { useContext } from 'react';
const AppContext = React.createContext({});
export function useApp() {
    return useContext(AppContext);
}
export default function App({ id, name, logo, onlylogo, endpoint, introUrl, children }) {
    return React.createElement(AppContext.Provider, { value: { id, name, logo, onlylogo, endpoint, introUrl } }, children);
}
